import { useEffect, useState } from 'react'

import apiRequest from '../lib/http'
import { useReportStaffBrand, useStaffBrandContext } from '../components/StaffBrand/StaffBrandContext'

// The identity of the firm this browser is acting as, for the chrome around the data.
//
// Deliberately null until the server answers, and null again if it never does: the chrome naming NO
// firm is a visible gap somebody reports, while the chrome naming the WRONG firm is invisible.
export const useActiveBrand = () => {
  const knownBrand = useStaffBrandContext()
  const [brand, setBrand] = useState(knownBrand)
  const reportBrand = useReportStaffBrand()

  useEffect(() => {
    let current = true
    const settle = (next) => {
      if (!current) return
      setBrand(next)
      if (reportBrand) reportBrand(next)
    }

    apiRequest.get('/branding/mine')
      .then((response) => settle(response.data?.data || null))
      .catch(() => settle(null))

    return () => { current = false }
  }, [reportBrand])

  return brand
}
